import request from "@/api/request"

// 收藏分页
export function collectPage(data) {
  return request({
    method: 'get',
    url:'/main/jobPostRedCollect/collectPage',
    params:data
  })
}